import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModulesComponent } from '../../../service/modules/modules.component';

@Component({
  selector: 'app-user-insert',
  templateUrl: './user-insert.component.html',
  styleUrls: ['./user-insert.component.scss']
})
export class UserInsertComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  public lang: any = localStorage.getItem("lang");
  public user_info: any = localStorage.getItem("user_info");
  public user_id = this.user_info.user_id;
  form1: FormGroup | any;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , private dialog: MatDialog, private matDialogRef: MatDialogRef<UserInsertComponent>) { }//end consructor

  ngOnInit() {
    this.create_form();
  }


  create_form() {
    this.form1 = new FormGroup({
      'title': new FormControl(null),
      'user': new FormControl(null),
      'email': new FormControl(null, [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      'cellphone': new FormControl(null, [Validators.pattern('[0-9]{1,}'), Validators.minLength(11), Validators.maxLength(11)]),
      'phone': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'address': new FormControl(null),
      'comment': new FormControl(null),
      'national_id': new FormControl(null, [Validators.pattern('[0-9]{1,}'), Validators.minLength(11), Validators.maxLength(11)]),
      'economic_id': new FormControl(null, [Validators.pattern('[0-9]{1,}'), Validators.minLength(12), Validators.maxLength(12)]),
      'post_code': new FormControl(null, [Validators.pattern('[0-9]{1,}'), Validators.pattern('[0-9]{1,}'), Validators.minLength(10), Validators.maxLength(10)]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'sex_title': new FormControl(null),
      'sex': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
    });
    this.form1.controls['title'].setValidators([Validators.required]);
  }


  insert(): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1.valid) {
      return false;
    }
    this.loading = true;
    var obj = {
      'address': 1519, "user_id": this.user_id
      , 'title': this.form1.value.title
      , 'user': this.form1.value.user
      , 'email': this.form1.value.email
      , 'cellphone': this.form1.value.cellphone
      , 'phone': this.form1.value.phone
      , 'address1': this.form1.value.address
      , 'comment': this.form1.value.comment
      , 'national_id': this.form1.value.national_id
      , 'economic_id': this.form1.value.economic_id
      , 'post_code': this.form1.value.post_code
      , 'sex': this.form1.value.sex
    };
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.matDialogRef.close(res['result'][0]);
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done Successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "این شماره همراه قبلا وجود داشته است";
          var pe_action = "بستن";
          this.recieve_message(true, 'Username must be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }//end if 
    )
  }//end insert


  load_services(id: number) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      data: { id: id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (id == 214) {
          this.form1.patchValue({
            'sex_title': res.title,
            'sex': res.id
          })
        }
      }
    )
  }



  reset_input(id: number) {
    if (id == 214) {
      this.form1.patchValue({
        'sex_title': null,
        'sex': null
      })
    }
  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}


